import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

interface NavItem {
  labelKey: string;
  route: string;
}

@Component({
    selector: 'app-define-sidebar',
    standalone: true,
    imports: [CommonModule, TranslateModule, RouterLink, RouterLinkActive],
    templateUrl: './define-sidebar.component.html',
    styleUrl: './define-sidebar.component.scss'
})
export class DefineSidebarComponent {
  readonly navItems: NavItem[] = [
    { labelKey: 'SIDEBAR.COMPANY_FIT', route: '/define/company-fit' },
    { labelKey: 'SIDEBAR.VALUE_ANALYSIS', route: '/define/value-analysis' },
    //{ labelKey: 'SIDEBAR.DEMO_AND_PROOFS', route: '/define/demo-and-proofs' }
  ];
}

